import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { formatGBP } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function ProductCard({ product, index = 0 }) {
  const { toggleWishlist, inWishlist } = useCart();
  const wished = inWishlist(product.id);
  return (
    <div className={`group rise rise-d${(index % 4) + 1}`} data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.id}`} className="block">
        <div className="product-img-wrap relative bg-sand aspect-[4/5]">
          <img src={product.images?.[0]} alt={product.name}
            className="product-img w-full h-full object-cover" loading="lazy" />
          {product.is_featured && (
            <span className="absolute top-4 left-4 eyebrow bg-white px-2 py-1 text-[10px]" data-testid="badge-featured">Atelier Pick</span>
          )}
          {product.stock !== undefined && product.stock < 5 && product.stock > 0 && (
            <span className="absolute top-4 right-4 eyebrow bg-[var(--gold)] text-white px-2 py-1 text-[10px]">Last Few</span>
          )}
        </div>
      </Link>
      <div className="pt-5 flex justify-between items-start gap-3">
        <div>
          <Link to={`/product/${product.id}`} className="font-serif text-lg leading-tight hover:text-[var(--gold)] transition-colors" data-testid={`product-name-${product.id}`}>
            {product.name}
          </Link>
          <p className="text-[11px] uppercase tracking-[0.2em] text-neutral-500 mt-1">{product.category}</p>
          <p className="mt-2 text-base font-light" data-testid={`product-price-${product.id}`}>{formatGBP(product.price)}</p>
        </div>
        <button onClick={(e) => { e.preventDefault(); toggleWishlist(product); }}
          aria-label="Toggle wishlist" data-testid={`wishlist-toggle-${product.id}`}
          className={`p-2 transition-colors ${wished ? "text-[var(--gold)]" : "text-neutral-500 hover:text-[var(--gold)]"}`}>
          <Heart strokeWidth={1.25} fill={wished ? "currentColor" : "none"} className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
